module.exports = __webpack_public_path__ + "./img/LogoWeb.ace1c267270d409dc77619a5e73ac154.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/LogoWeb.png
// module id = ./public/img/LogoWeb.png
// module chunks = 0